import React, { useState } from "react";
import styles from "./insights.module.css";
import { Col, Container, Row } from "react-bootstrap";
import { Heading, Paragraph } from "../TextComponents/TextComponents";
import { Link } from "react-router-dom";

const Insights = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    "Global Trade Trends",
    "Renewable Energy",
    "Technology & Innovation",
    "Industry Spotlights",
    "Sustainability Practices",
  ];

  const resourceData = [
    {
      id: 1,
      Image: "/images/news/farming.png",
      Heading: "The Role of IoT in Revolutionizing Solar Energy Monitoring",
      Title:
        "From real-time maintenance alerts to optimizing energy outputs, IoT is powering the next generation of solar energy solutions.",
      Title2: "Read More",
    },
    {
      id: 2,
      Image: "/images/news/stone.png",
      Heading: "Minerals in the Global Supply Chain: Challenges",
      Title:
        "As the demand for critical minerals rises, discover how businesses can adapt to the evolving supply chain landscape.",
      Title2: "Read More",
    },
    {
      id: 3,
      Image: "/images/news/water.png",
      Heading: "The Future of Urban Water Supply in the UAE",
      Title:
        "As urbanization accelerates, the demand for clean and efficient water distribution systems is soaring.",
      Title2: "Read More",
    },
  ];

  return (
    <React.Fragment>
      <Container className="my-5">
        <Row>
          <Col md={6} sm={12}>
            <Heading>Categories of Insights</Heading>
            <Paragraph color="#62677A">
              Explore topics that matter most to your industry and business.
            </Paragraph>
          </Col>
        </Row>

        <div className={styles.tabs_container}>
          {tabs.map((tab, index) => (
            <div
              key={index}
              className={`${styles.tab} ${
                activeTab === index ? styles.activeTab : ""
              }`}
              onClick={() => setActiveTab(index)}
            >
              {tab}
            </div>
          ))}
        </div>

        {activeTab === 0 && (
          <Container>
            <Row>
              <Col md={6} sm={12}>
                <div className={styles.tab_content}>
                  <img src="/images/news/image.png" alt="farming" />
                </div>
              </Col>
              <Col md={6} sm={12}>
                <div className={styles.right_content}>
                  <h1>
                    India’s Push Toward Renewable Energy: What It Means for
                    Global Trade
                  </h1>
                  <p>
                    India's ambitious plan to achieve 500 GW of non-fossil
                    energy capacity by 2030 is reshaping the energy market.
                    Here's how businesses can align with this monumental shift.
                    <br />
                    <br />
                    India's ambitious plan to achieve 500 GW of non-fossil
                    energy capacity by 2030
                  </p>
                  <Link to={"/details"}>Read More</Link>
                </div>
              </Col>
            </Row>

            <Row>
              {resourceData.map((item) => (
                <Col key={item.id} md={4} className="mb-4">
                  <div className={styles.card}>
                    <img  loading="lazy" src={item.Image} alt="resource"/>
                      <h5>{item.Heading}</h5>
                      <p>{item.Title}</p>
                      <Link to="#">{item.Title2}   </Link>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        )}
      </Container>
    </React.Fragment>
  );
};

export default Insights;
